module.exports = __webpack_public_path__ + "static/Traceability 3-af1db03877b57859418aa0c092a0951d.png";